import { AddIcCallOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { EmptyState } from "components/EmptyState";
import i18n from "i18n/i18n";
import { ReactComponent as AddSvg } from "assets/Svgs/AddSvg.svg";
import DocumentationTab from "./DocumentationTab";
import { useBoundStore } from "store/store";

function Documentation(props: any) {

  const lang:any = useBoundStore((state) => state.lang);

  const { machineData } = props;

  return (
    <div>
      {" "}
      
      <DocumentationTab machineData={machineData} />
    </div>
  );
}
export default Documentation;
